import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { RegistrationService } from '../shared/registration.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationStateModel, RegistrationState } from '../state/registration.state';
import { SubSink } from 'subsink';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';

const ROUTE_DOCUMENT_UPLOAD = 'document-upload/';
const EMERGENCY_RESPONSE_TRAINING = 'EmergencyResponseTraining';
const FATIGUE_MANAGEMENT__TRAINING = 'FatigueManagementTraining';
const HAZARDOUS_MATERIALS_ENDORSEMENT = 'HazardousMaterialsEndorsement';
const HOURS_OF_SERVICE = 'HoursOfService';
const MANDATORY_ENTRY_LEVEL_TRAINING = 'MandatoryEntryLevelTraining';
const MOUNTAIN_DRIVING = 'MountainDriving';
const TRANSPORTATION_OF_DANGEROUS_GOODS = 'TransportationOfDangerousGoods';
const VEHICLE_INSPECTIONS = 'VehicleInspections';
const WINTER_DRIVING = 'WinterDriving';
const WORKPLACE_HAZARDOUS_MATERIALS_INFORMATION_SYSTEM = 'WorkplaceHazardousMaterialsInformationSystem';
const DEFENSIVE_DRIVING = 'DefensiveDriving';
const CARGO_SECUREMENT = 'CargoSecurement';
const DOCUMENT_TYPES = [
  EMERGENCY_RESPONSE_TRAINING,
  FATIGUE_MANAGEMENT__TRAINING,
  HAZARDOUS_MATERIALS_ENDORSEMENT,
  HOURS_OF_SERVICE,
  MANDATORY_ENTRY_LEVEL_TRAINING,
  MOUNTAIN_DRIVING,
  TRANSPORTATION_OF_DANGEROUS_GOODS,
  VEHICLE_INSPECTIONS,
  WINTER_DRIVING,
  WORKPLACE_HAZARDOUS_MATERIALS_INFORMATION_SYSTEM,
  DEFENSIVE_DRIVING,
  CARGO_SECUREMENT
];
const UPLOADED_STATUS = 'uploaded';
const PENDING_STATUS = 'pending';

@Component({
    selector: 'app-driver-training-certificates',
    templateUrl: './driver-training-certificates.component.html',
    styleUrls: ['./driver-training-certificates.component.scss'],
    standalone: false
})
export class DriverTrainingCertificatesComponent implements OnInit {
  trainingDocumentTypes: any;
  selectedDocumentType: string;
  loading: boolean;
  private subs = new SubSink();
  cargoSecurement: any;
  defensiveDriving: any;
  workplaceHazardousSystem: any;
  winterDriving: any;
  vehicleInspections: any;
  transportationOfDangerousGoods: any;
  mountainDriving: any;
  melt: any;
  hos: any;
  hazardousMaterial: any;
  fatigueManagement: any;
  emergencyResponseTrainingDocument: any;

  constructor(
    private readonly location: Location,
    private readonly registrationService: RegistrationService,
    private readonly router: Router,
    private readonly activedRoute: ActivatedRoute,
    private readonly store: Store
  ) {}

  ngOnInit(): void {
    this.loadDriverDocuments();
  }

  backAction() {
    this.location.back();
  }

  loadDriverDocuments(): void {
    this.loading = true;
    this.subs.add(
      this.registrationService
        .loadDriver()
        .pipe(map(() => this.store.selectSnapshot(RegistrationState.notification)))
        .subscribe((notificationStateModel: NotificationStateModel) => {
          if (notificationStateModel && notificationStateModel.notifications) {
            notificationStateModel.notifications.forEach(notifincation => {
              if (
                notifincation.type == EMERGENCY_RESPONSE_TRAINING &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.emergencyResponseTrainingDocument = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == FATIGUE_MANAGEMENT__TRAINING &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.fatigueManagement = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == HAZARDOUS_MATERIALS_ENDORSEMENT &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.hazardousMaterial = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == HOURS_OF_SERVICE &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.hos = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == MANDATORY_ENTRY_LEVEL_TRAINING &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.melt = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == MOUNTAIN_DRIVING &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.mountainDriving = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == TRANSPORTATION_OF_DANGEROUS_GOODS &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.transportationOfDangerousGoods = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == VEHICLE_INSPECTIONS &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.vehicleInspections = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == WINTER_DRIVING &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.winterDriving = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == WORKPLACE_HAZARDOUS_MATERIALS_INFORMATION_SYSTEM &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.workplaceHazardousSystem = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == DEFENSIVE_DRIVING &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.defensiveDriving = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
              if (
                notifincation.type == CARGO_SECUREMENT &&
                (notifincation.status == UPLOADED_STATUS || notifincation.status == PENDING_STATUS)
              ) {
                this.cargoSecurement = {
                  generationDate: notifincation.createdDate,
                  typeDisplayName: notifincation.name,
                  type: notifincation.type,
                  isPresent: true,
                  issuingOrganization: notifincation?.issuingOrganization
                };
              }
            });
          }
          this.loading = false;
        })
    );
  }

  uploadFile(type: string, isDocumentPresent: boolean) {
    this.selectedDocumentType = type;
    if (DOCUMENT_TYPES.includes(this.selectedDocumentType) && isDocumentPresent) {
      this.registrationService.navigateToDocumentType(this.selectedDocumentType, this.activedRoute);
    } else {
      this.router.navigate([ROUTE_DOCUMENT_UPLOAD + this.selectedDocumentType]);
    }
  }
}
